// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"22b980f3","787":"453dbc21"}[chunkId] + ".chunk.js";
};